<template>
  <ActionButton mode="secondary" :actions="actions" :loading="loading" />
</template>

<script lang="ts" setup>
import { PrimeIcons } from '@primevue/core/api';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { RygenMenuItem, Severity } from '@rygen/rygen-ui/model';

import { RateShopAction } from '@/model';

import ActionButton from '@rygen/rygen-ui/components/button/ActionButton.vue';

const props = defineProps({
  canRequestSpotMarketBid: {
    type: Boolean,
    default: () => false,
  },
  canCancelAllSpotMarketBids: {
    type: Boolean,
    default: () => false,
  },
  loading: {
    type: Boolean,
    default: () => false,
  },
});
const { canRequestSpotMarketBid, canCancelAllSpotMarketBids } = toRefs(props);
const emit = defineEmits<{
  (event: 'request-spot-market-bid'): void;
  (event: 'cancel-all-spot-market-bids'): void;
}>();

const { t } = useI18n();

const actions = computed((): RygenMenuItem[] => [
  {
    key: RateShopAction.REQUEST_SPOT_MARKET_BID,
    label: t('carrierPortal.spotMarket.requestBid'),
    icon: PrimeIcons.DOLLAR,
    command: () => emit('request-spot-market-bid'),
    visible: canRequestSpotMarketBid.value,
  },
  {
    key: RateShopAction.CANCEL_ALL_SPOT_MARKET_BIDS,
    label: t('carrierPortal.spotMarket.cancelAllSpotMarkets'),
    icon: PrimeIcons.TIMES,
    severity: Severity.DANGER,
    command: () => emit('cancel-all-spot-market-bids'),
    visible: canCancelAllSpotMarketBids.value,
  },
]);
</script>
